import type { ISubscriptionAdapter } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters/types';
import { filterAndGroupThemes, buildBaseFilterGroups } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/helpers';

export const corporateAdapter: ISubscriptionAdapter = {
  shouldUse: (context) =>
    Boolean(context.currentMarket),

  filterThemes: (context) => {
    if (!context.currentMarket || !context.currentProduct) {
      return { groupedThemes: {}, themesIds: {} };
    }

    const currentMarketId = context.currentMarket.getId();
    return filterAndGroupThemes(
      context.themes,
      ({ marketId, productId }) =>
        marketId === currentMarketId && productId === context.currentProduct?.id,
    );
  },

  getRegionIds: (context) => {
    if (!context.currentMarket) {
      return [];
    }

    const marketRegion = context.currentMarket.belongsToRegion();
    return marketRegion ? [marketRegion.getId()] : [];
  },

  getModalTitle: (context) => {
    const marketName = context.currentMarket?.getDisplayName() || '';
    const productAbbr = context.currentProduct?.abbreviation || '';
    return `${ marketName } ${ productAbbr } Email Alerts`;
  },

  shouldFilterByProduct: true,

  buildFilterGroups: (groupedThemes, themesIds, context) => {
    const marketName = context.currentMarket?.getDisplayName() || '';
    const productAbbr = context.currentProduct?.abbreviation || '';

    return buildBaseFilterGroups(
      groupedThemes,
      themesIds,
      (articleTypeTitle) => `All ${ marketName } ${ productAbbr } ${ articleTypeTitle }`,
    );
  },
};
